<template>
  <div class="home">
     
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <a class="navbar-brand" href="#"> System: </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <a class="nav-link" href="#"><router-link to="/home">Home</router-link> <span class="sr-only">(current)</span></a>
        </li>
         <li class="nav-item">
          <a class="nav-link" href="#" ><router-link to="/home/centre"  active-class="centre_active">centre</router-link></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#"><router-link to="/home/about">About</router-link></a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled">Disabled</a>
        </li>
      </ul>
       <span class="userName">欢迎光临：{{ name }}</span>
       <a class="" href="#" @click="logOut"> 退出登录</a>
     
    </div>
    
  </nav>

   <section  style="padding: 3.2rem 0 0 0 ;"> 
     <router-view/>
    </section> 
  </div>
</template>

<script>
// import axios from 'axios'

// @ is an alias to /src

import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
   data() {
    return {
     name:'',
   }
  },
  components: {

  },
  
   mounted() {
    this.getname()
  },
  methods: {
    getname(){
       this.name = localStorage.getItem('token').split("-")[1];
    },
    logOut() {
      localStorage.clear()
       window.location.href = '/login' 

  // 用 replace + 延迟 10ms，彻底避免冲突
  // setTimeout(() => {
  //   this.$router.replace('/')
  // }, 10)
}
  }
}
</script>


<style scoped>
.navbar-brand{font-size: 1.05rem;}
.names{ text-align: left; height: 1rem; margin-top: 0.5rem;}
.userName{ padding: 0  1rem 0 0; color:#409EFF; font-weight: normal;}
nav a.centre_active{
  color: #fff;
    font-weight: bold;

}
</style>